import { render, staticRenderFns } from "./appointmentTitle.vue?vue&type=template&id=1da98003&scoped=true"
import script from "./appointmentTitle.vue?vue&type=script&lang=ts"
export * from "./appointmentTitle.vue?vue&type=script&lang=ts"
import style0 from "./appointmentTitle.vue?vue&type=style&index=0&id=1da98003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da98003",
  null
  
)

export default component.exports